import PropTypes from 'prop-types';
import React from 'react';

import { ModalFloatingHeader } from '@components/modal/new/modal-header';
import { profileDefaultProps, profilePropTypes } from '../../../prop-types';
import { AccountNav } from '../../account-nav/new';
import { Modal } from '../../modal/new';

const AccountNavigation = ({ handleSignOut, isOpen, onClose }) => {
  return (
    <Modal
      open={isOpen}
      handleClose={onClose}
      variant="side"
      header={<ModalFloatingHeader px="20px" dark handleClose={onClose} />}
      hideBottomDecal
    >
      <AccountNav handleSignOut={handleSignOut} />
    </Modal>
  );
};

AccountNavigation.propTypes = {
  ...profilePropTypes,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

AccountNavigation.defaultProps = profileDefaultProps;

export { AccountNavigation };
